import request from '@/utils/request'

export const getAll = (data) => {
  return request({
    url: '/downLoadFile/getAll',
    method: 'POST',
    params: data
  })
}
